import classnames from 'classnames/bind';

import { CoreIcon } from '@autopass-web/mochi-icons';

import styles from './index.module.sass';
const cx = classnames.bind(styles);

interface powerByProps {
  style?: any;
  className?: any;
  invert?: boolean;
}

const PowerBy = ({ invert = false, style = {}, className }: powerByProps) => {
  const powerByClass = cx({
    powerBy: true,
  });
  return (
    <div className={`${powerByClass} ${className} `} style={style}>
      <CoreIcon
        src={invert ? '/assets/pba_dark.svg' : '/assets/pba_light.svg'}
      />
    </div>
  );
};

export default PowerBy;
